import { render, staticRenderFns } from "./Spots.vue?vue&type=template&id=28bf045a&scoped=true&"
import script from "./Spots.vue?vue&type=script&lang=js&"
export * from "./Spots.vue?vue&type=script&lang=js&"
import style0 from "./Spots.vue?vue&type=style&index=0&id=28bf045a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf045a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})
